import {Component, Inject} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ENV_TOKEN, EnvInterface} from 'env-config';
import {ExternalRedirect} from 'auth';

@Component({
  selector: 'app-frequently-asked-questions-component',
  templateUrl: './frequently-asked-questions-component.html',
  styleUrl: './frequently-asked-questions-component.scss',
})
export class FrequentlyAskedQuestionsComponent {

  faqs: { question: string; paragraphs: SafeHtml[] }[];

  constructor(@Inject(ENV_TOKEN)
              protected readonly environment: EnvInterface,
              protected externalRedirect: ExternalRedirect,
              private sanitizer: DomSanitizer) {
    this.faqs = [
      {
        question: 'Do I have to pay more to use CGP RevisionHub?',
        paragraphs: [`Nope! CGP RevisionHub, and all its goodies, are included with your book — just use the unique code printed on the inside cover to get started.`]
      },
      {
        question: 'Which subjects can I revise for with CGP RevisionHub?',
      paragraphs: [`CGP RevisionHub is currently available for AQA GCSE Science, AQA and Edexcel GCSE Languages, and AQA GCSE English Language. See all our books with CGP RevisionHub <a class="cgp-link" (click)="externalRedirect.ssoRedirect(\`${environment.app.mediaBaseUrl}/secondary-books/gcse/cgp-revisionhub\`)">here</a> — there are even more coming soon!`]
      },
      {
        question: 'How do I use CGP RevisionHub with my book?',
        paragraphs: [`You'll notice lots of QR codes scattered throughout your book. Give them a scan and you'll automatically be taken to the relevant quiz, test or other revision thingy-ma-jig so you can go over what you've just learned!`]
      },
      {
        question: `My CGP RevisionHub isn't working — what do I do?`,
        paragraphs: [
          `If you can't find the answer in these FAQs, it's time to contact our friendly <a class="cgp-link" (click)="externalRedirect.ssoRedirect(\`${environment.app.mediaBaseUrl}/contact-us\`)">Customer Services team</a>.`,
          `You could also ask your friendly neighbourhood psychic, but they will charge...`
        ]
      },
      {
        question: 'Do I need an internet connection to use CGP RevisionHub?',
        paragraphs: [`Yes, you do. But don't cancel your revision retreat to a remote mountain cave just yet — lots of our books with CGP RevisionHub include useful bits that you can download as PDFs to access offline. Phew.`]
      },
      {
        question: 'If I log in on a different device, will all my progress be saved?',
        paragraphs: [`Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you. We've got you covered!`]
      },
      {
        question: 'Can I share my quiz scores and test results with other people?',
        paragraphs: [`You can't share results directly via CGP RevisionHub, but there are other means... Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?`]
      },
      {
        question: 'Will I always have access to CGP RevisionHub?',
        paragraphs: [`Once you use a code, you'll have access for three years. And they'll be three whole years of bliss, we promise...`]
      }
    ].map(faq => ({
      question: faq.question,
      paragraphs: faq.paragraphs.map(p => this.sanitizer.bypassSecurityTrustHtml(p))
    }));
  }
}
